import { Col, Form, Input, message, Modal, Row, Switch, Tree } from "antd";
import { Rule } from "antd/lib/form";
import TextArea from "antd/lib/input/TextArea";
import { roleApi } from "api/role.api";
import React, { useEffect, useImperativeHandle, useState } from "react";
import { adminRoutes } from "router";
import { ModalStatus } from "types/modal";
import { Permission, Role } from "types/role";
import { Staff } from "types/staff";

const rules: Rule[] = [{ required: true, message: "Bắt buộc" }];

interface ITreeData {
  title: string;
  key: string;
  children?: ITreeData[];
}

export interface RoleModal {
  handleCreate: () => void;
  handleUpdate: (Role: Role) => void;
}
interface RoleModalProps {
  onClose: () => void;
  onSubmitOk: () => void;
}

export const RoleModal = React.forwardRef(({ onClose, onSubmitOk }: RoleModalProps, ref) => {
  const [form] = Form.useForm<Role>();
  const [loading, setLoading] = useState(false);
  const [treeData, setTreeData] = useState<ITreeData[]>([]);
  const [checkedKeys, setCheckedKeys] = useState<string[]>([]);
  const [permissions, setPermissions] = useState<Permission[]>([]);

  console.log("checkedKeys", checkedKeys);

  const [visible, setVisible] = useState(false);
  const [status, setStatus] = useState<ModalStatus>("create");
  const [role, setRole] = useState<Role>();

  useImperativeHandle<any, RoleModal>(
    ref,
    () => ({
      handleCreate() {
        form.resetFields();
        setVisible(true);
        setStatus("create");
        setRole(undefined);

        generateTreeData();
        fetchPermissions();
      },
      async handleUpdate(Role: Role) {
        const detailRole = await roleApi.findOne(Role.id);

        form.setFieldsValue({ ...detailRole.data });
        setCheckedKeys(detailRole.data.permissions.map((e: Permission) => e.path));

        setVisible(true);
        setStatus("update");
        setRole(Role);

        generateTreeData();
        fetchPermissions();
      },
    }),
    [],
  );

  // useEffect(() => {
  //   form.setFieldsValue({ ...role });
  //   generateSelectedKeys();
  //   return () => {};
  // }, [role]);

  const fetchPermissions = async () => {
    const res = await roleApi.getPermission();
    setPermissions(res.data);
  };

  const generateSelectedKeys = async () => {
    if (role?.id) {
      const res = await roleApi.findOne(role.id);
      const permissions: Permission[] = res.data.permissions;

      setCheckedKeys(permissions.map((e) => e.path));
    }
  };

  const generateTreeData = () => {
    if (treeData.length) {
      return;
    }
    for (const route of adminRoutes) {
      const data: ITreeData = {
        title: route.title || "",
        key: route.path || "",
      };

      treeData.push(data);
      if (route.children) {
        data.children = [];
        for (const childRoute of route.children) {
          data.children.push({
            title: childRoute.title || "",
            key: route.path + "/" + childRoute.path || "",
          });
        }
      }
    }

    console.log("generateTreeData", treeData);

    setTreeData([...treeData]);
  };

  const createData = async (data: any) => {
    setLoading(true);
    try {
      const res = await roleApi.create(data);
      message.success("Tạo mới thành công");
      onClose();
      onSubmitOk();
    } finally {
      setLoading(false);
    }
  };

  const updateData = async (data: any) => {
    setLoading(true);
    try {
      const res = await roleApi.update(role?.id || 0, data);
      message.success("Cập nhật thành công");
      onClose();
      onSubmitOk();
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    const valid = await form.validateFields();
    const data = {
      role: form.getFieldsValue(),
      ...(status === "update" && {
        permissionIds: checkedKeys.map((e) => permissions.find((p) => p.path === e)?.id).filter(Boolean),
      }),
    };

    if (status == "create") {
      createData(data);
    } else {
      updateData(data);
    }

    handleClose();
    onSubmitOk();
  };

  const onCheck = (checkedKeys: any, info: any) => {
    setCheckedKeys(checkedKeys);
  };

  const handleClose = () => {
    form.resetFields();
    setCheckedKeys([]);
    setVisible(false);
  };

  return (
    <Modal
      onCancel={handleClose}
      open={visible}
      title={status == "create" ? "Tạo mới quyền" : "Cập nhật quyền"}
      style={{ top: 20 }}
      width={700}
      confirmLoading={loading}
      onOk={() => {
        handleSubmit();
      }}
    >
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label="Tên quyền" name="name" rules={rules}>
              <Input placeholder="" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Mô tả" name="description">
              <TextArea rows={3} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Admin" name="isAdmin">
              <Switch />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Khách hàng" name="isCustomer">
              <Switch />
            </Form.Item>
          </Col>
        </Row>

        {status === "update" ? (
          <div>
            <span className="text-sm font-medium mb-2 block">Danh sách quyền</span>
            <Tree checkable onCheck={onCheck} treeData={treeData} checkedKeys={checkedKeys}></Tree>
          </div>
        ) : null}
      </Form>
    </Modal>
  );
});
